<template>
    <div class="app">
        <div class="page" :class="{ 'page-no-tabbar': !showTabbar }">
            <router-view />
            <footer v-if="showAppFooter" class="app-footer" :class="{ 'app-footer-with-tabbar': showTabbar }">
                <!-- <div>
                    非急救转运平台
                    <a class="app-footer-link" href="https://96120.cn" target="_blank" rel="noopener noreferrer">96120.cn</a>
                </div> -->
                <div>
                    <!-- href="https://beian.miit.gov.cn/#/"  -->
                    <a class="app-footer-link" target="_blank" rel="noopener noreferrer">京ICP备2026022994号-1</a>
                </div>
            </footer>
        </div>
        <van-tabbar v-if="showTabbar" v-model="active" route>
            <van-tabbar-item
                v-for="item in tabbarItems"
                :key="item.to"
                :icon="item.icon"
                :to="item.to"
            >
                {{ item.label }}
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
import { getUser } from './utils/auth'

const PATIENT_TABBAR_ITEMS = [
    { label: '首页', icon: 'home-o', to: '/' },
    { label: '订单', icon: 'orders-o', to: '/orders' },
    { label: '我的', icon: 'user-o', to: '/profile' }
]

const DRIVER_TABBAR_ITEMS = [
    { label: '工作台', icon: 'home-o', to: '/driver-home' },
    { label: '抢单池', icon: 'coupon-o', to: '/driver-grab-pool' },
    { label: '我的任务', icon: 'todo-list-o', to: '/driver-my-tasks' },
    { label: '我的', icon: 'user-o', to: '/profile' }
]

export default {
    name: 'App',
    data () {
        return {
            active: 0
        }
    },
    computed: {
        // 返回当前页面是否需要隐藏底部导航。
        showTabbar () {
            return !this.$route.meta.hideTabbar
        },
        // 返回当前页面是否展示全局备案页脚。
        showAppFooter () {
            return !['BindPhone', 'WechatAuth'].includes(this.$route.name)
        },
        // 返回当前路由下最新的登录用户缓存。
        currentUser () {
            void this.$route.fullPath
            return getUser()
        },
        // 返回当前账号类型对应的底部导航配置。
        tabbarItems () {
            return Number(this.currentUser?.user_type) === 2 ? DRIVER_TABBAR_ITEMS : PATIENT_TABBAR_ITEMS
        }
    }
}
</script>

<style>
.app {
    min-height: calc(100vh - 100px);
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}

.page {
    flex: 1;
    padding-bottom: .5rem;
    box-sizing: border-box;
}

.page-no-tabbar {
    padding-bottom: 0;
}

.app-footer {
    padding: 18px 16px 24px;
    text-align: center;
    font-size: 12px;
    line-height: 1.8;
    color: #8a94a6;
    background: #f6f8fb;
}

.app-footer-with-tabbar {
    padding-bottom: 72px;
}

.app-footer-link {
    color: #6f87a2;
    text-decoration: none;
}
</style>
